import { NumberFormatOptionsType } from '../types';

import { MAX_POSSIBLE_NUMBER_OF_DECIMAL_PLACES } from 'app/constants/userRestrictions';

import { formatNumber } from '../formatNumber/formatNumber';

export const formatPrice = (
  value: number,
  props: NumberFormatOptionsType = {},
): string => {
  let decimals = props?.decimals || MAX_POSSIBLE_NUMBER_OF_DECIMAL_PLACES; // 1 =< value < 100

  if (!props?.decimals && value >= 100 && value < 1000) {
    decimals = 1;  // 100 =< value < 1000
  }
  else if (!props?.decimals && value >= 1000) {
    decimals = 0;  // 1000 =< value
  }

  return formatNumber(value, { ...props, decimals });
};

